import React, { useContext } from "react";
import ConfiguratorContext from "./ConfiguratorContext";
import ConfiguratorSurveyOutputCalculation from "./ConfiguratorSurveyOutputCalculation";
import ConfiguratorSurveyOutputQuestion from "./ConfiguratorSurveyOutputQuestion";
import ConfiguratorSurveyOutputRender from "./ConfiguratorSurveyOutputRender";
import ConfiguratorSurveyRecursiveQuestion from "./ConfiguratorSurveyRecursiveQuestion";
import { getSeparator } from "./ServiceConfiguratorSeparator";
import ConfiguratorSurveyJsonOutputValue from "@components/ConfiguratorSurveyJsonOutputValue";

const ConfiguratorSurveyOutput = ({ output, role, ...rest }) => {
  const { output_type, ...outputRest } = output;
  const { responses } = useContext(ConfiguratorContext);
  const activeResponses = rest.responses || responses;

  if (outputRest.type === "recursive_question") {
    return (
      <ConfiguratorSurveyRecursiveQuestion
        key={outputRest.id}
        list={activeResponses?.[outputRest.id]?.recursive_question_value || []}
        role={role}
        table_mode={outputRest.metadata_?.table_mode}
        {...outputRest}
        {...rest}
      />
    );
  }

  switch (output_type) {
    case "calculation":
      return (
        <ConfiguratorSurveyOutputCalculation
          output={outputRest}
          role={role}
          {...rest}
        />
      );
    case "question":
      return (
        <ConfiguratorSurveyOutputQuestion
          output={outputRest}
          role={role}
          {...rest}
        />
      );
    case "json_output_value":
      return (
        <ConfiguratorSurveyJsonOutputValue
          output={outputRest}
          role={role}
          {...rest}
        />
      )
    case "separator":
      return getSeparator(output.output_input_id, true)

    default:
      return (
        <ConfiguratorSurveyOutputRender
          {...outputRest}
          simpleOutput
          output_type={output_type}
          realtime={rest.realtime}
          role={role}
        />
      );
  }
};

export default ConfiguratorSurveyOutput;
